import billingInstance from "./axios-base";
// import providerInstance from "./api-provider";
import getToken from "./token";
import getUserName from "store/getUserName";
import getPracticeId from "./practiceId";

export const billing = async ({
  url,
  payload,
  params,
  method = "POST",
  contentType = "application/json",
  headers = {},
  data = {},
  addUserName,
  addPracticeId = true,
}) => {
  const token = getToken();
  let newPayload = payload;
  if (addUserName) newPayload = { ...newPayload, user_name: getUserName() };
  if (addPracticeId)
    newPayload = { ...newPayload, practice_id: getPracticeId() };
  let response = await billingInstance({
    url,
    method,
    data: newPayload,
    params: params,
    headers: {
      "Content-Type":
        payload instanceof FormData ? "multipart/form-data" : contentType,
      Authorization: token ? `Bearer ${token}` : undefined,
      ...headers,
    },
    ...data,
  });
  return response;
};
